// frontend/src/config/helpCenter.js
//
// Single source of truth for the public help-centre URL
// (components/layout/HelpMenu.jsx).
//
// The `||` here is build-time configuration, not an error fallback: the var is
// legitimately absent in local dev, and the literal below is the real public
// URL rather than a substituted guess. Nothing is being masked — an unset var
// yields the same address the deploy would have set.

export const HELP_CENTER_URL = import.meta.env.VITE_HELP_CENTER_URL || 'https://help.manexys.com';
